module.exports = __webpack_public_path__ + "media/friends.d62ceb27.webm";